/* WKS custom: menutracking desktopnavigatie (GA4-event menu_click)
   Geïsoleerd bestand; raakt het thema-JS niet aan.
   - Decoreert de bestaande desktopmenulinks met data-menu-kolom / data-menu-label
     (het nieuwe megamenu levert die attributen straks zelf server-side aan;
     bestaande attributen worden nooit overschreven).
   - Stuurt bij elke klik in de desktopnavigatie een GA4-event `menu_click`
     met parameters: menu (balk|waskommen|accessoires), kolom
     (materiaal|ruimte|maat|vorm-kleur|hulp|alle|balk) en label (zichtbare linktekst).
   - In themapreview (Shopify.theme.role != 'main') gaat debug_mode mee,
     zodat de events in GA4 DebugView zichtbaar zijn. */
(function () {
  'use strict';
  if (window.wksMenuTrackingLoaded) return;
  window.wksMenuTrackingLoaded = true;

  var KOLOM_MAP = {
    'materiaal/stijl': 'materiaal',
    'materiaal': 'materiaal',
    'vorm': 'vorm-kleur',
    'kleur': 'vorm-kleur',
    'vorm & kleur': 'vorm-kleur',
    'ruimte': 'ruimte',
    'afmeting': 'maat',
    'maat': 'maat',
    'hulp bij kiezen': 'hulp',
    'hulp': 'hulp'
  };

  function clean(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function mapKolom(header) {
    var key = clean(header).toLowerCase();
    return KOLOM_MAP[key] || 'alle';
  }

  function decorate(nav) {
    // Niveau 1: de balk zelf
    nav.querySelectorAll('a.menu-lv-1__action').forEach(function (a) {
      if (!a.dataset.menuKolom) {
        a.dataset.menuMenu = 'balk';
        a.dataset.menuKolom = 'balk';
        a.dataset.menuLabel = clean(a.textContent);
      }
    });

    // Uitklappanelen: menu-naam = de bijbehorende balk-link
    nav.querySelectorAll('a.menu-lv-1__action').forEach(function (topLink) {
      var li = topLink.closest('li') || topLink.parentElement;
      if (!li) return;
      var panel = li.querySelector('.menu-dropdown, .dropdown-menu, .site-nav-sub');
      if (!panel) return;
      var menuNaam = clean(topLink.textContent).toLowerCase();
      if (menuNaam !== 'waskommen' && menuNaam !== 'accessoires') menuNaam = 'balk';

      panel.querySelectorAll('a[href]').forEach(function (a) {
        if (a.dataset.menuKolom) return; // nieuw menu levert zelf attributen
        var kolom = 'alle';
        var group = a.closest('.site-nav.dropdown, [data-gridItem]');
        if (group) {
          var head = group.querySelector('a.site-nav-title');
          kolom = mapKolom(head ? clean(head.textContent) : '');
        }
        a.dataset.menuMenu = menuNaam;
        a.dataset.menuKolom = kolom;
        a.dataset.menuLabel = clean(a.textContent);
      });
    });
  }

  function isPreview() {
    try {
      return !!(window.Shopify && window.Shopify.theme && window.Shopify.theme.role !== 'main');
    } catch (e) {
      return false;
    }
  }

  function send(params) {
    if (isPreview()) params.debug_mode = true;
    // Alleen naar de GA4-property sturen; voorkomt dubbele verwerking via de
    // GT-container en ruis richting Google Ads.
    params.send_to = 'G-KNDJB21X1J';
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'menu_click', params);
      return true;
    }
    if (Object.prototype.toString.call(window.dataLayer) === '[object Array]') {
      // gtag-compatibele fallback: arguments-object pushen
      (function () { window.dataLayer.push(arguments); })('event', 'menu_click', params);
      return true;
    }
    return false;
  }

  function onClick(event) {
    var a = event.target && event.target.closest ? event.target.closest('a[data-menu-label]') : null;
    if (!a) return;
    var params = {
      menu: a.dataset.menuMenu || 'balk',
      kolom: a.dataset.menuKolom || 'alle',
      label: a.dataset.menuLabel || clean(a.textContent)
    };
    var ok = send(params);
    if (isPreview()) {
      try { console.log('[wks-menu-tracking] menu_click', params, 'verzonden:', ok); } catch (e) { /* stil */ }
    }
  }

  function init() {
    var nav = document.querySelector('.section-header-navigation .header__inline-menu, #HeaderNavigation');
    if (!nav) return;
    // Alleen desktopnavigatie; het mobiele menu ([data-wks-mnav]) blijft buiten beeld.
    decorate(nav);
    nav.addEventListener('click', onClick, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
